// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"854":"pdfjs","885":"pdf-lib"}[chunkId] || chunkId) + "." + {"54":"3096df3a","273":"de1d489d","427":"9f348d7f","453":"137ddf63","854":"892ca143","885":"0226859b"}[chunkId] + ".chunk.js";
};